module.exports = __webpack_public_path__ + "img/download-app-store-200x66.08684d14.png";